module.exports = "/assets/data/675be79d8e7c78e7d45ed9d0f841d8b6-WV9.data.json";